import { lazy } from 'react';
import { typedRoutes } from './utils/module-interfaces';
import { PATHS } from './soft-paths/solutions';

export const ROUTES = typedRoutes({
    SOLUTIONS: {
        ...PATHS.SOLUTIONS,
        id: 'SOLUTIONS',
        name: 'Solutions',
        i18nBase: 'solutions:module.solutions',
        i18nId: 'solutions:module.solutions.menu-label',
        displayInMenu: false,
        component: lazy(() => import('../components/modules/solutions/solutions')),
    },
    GAMING: {
        ...PATHS.GAMING,
        id: 'GAMING',
        name: 'Gaming',
        i18nBase: 'solutions:module.gaming',
        i18nId: 'solutions:module.gaming.menu-label',
        component: lazy(() => import('../components/modules/solutions/gaming/gaming')),
    },
    AUTOMOTIVE: {
        ...PATHS.AUTOMOTIVE,
        id: 'AUTOMOTIVE',
        name: 'Automotive',
        i18nBase: 'solutions:module.wwise_automotive',
        i18nId: 'solutions:module.wwise_automotive.menu-label',
        component: lazy(() => import('../components/modules/solutions/automotive/automotive')),
    },
    LBE: {
        ...PATHS.LBE,
        id: 'LBE',
        name: 'LocationBasedEntertainment',
        i18nBase: 'solutions:module.lbe',
        i18nId: 'solutions:module.lbe.menu-label',
        component: lazy(
            () =>
                import(
                    '../components/modules/solutions/location-based-entertainment/location-based-entertainment'
                )
        ),
    },
    SIMULATION: {
        ...PATHS.SIMULATION,
        id: 'SIMULATION',
        name: 'Simulation',
        i18nBase: 'solutions:module.simulation',
        i18nId: 'solutions:module.simulation.menu-label',
        component: lazy(() => import('../components/modules/solutions/simulation/simulation')),
    },
    CONSUMER_ELECTRONICS: {
        ...PATHS.CONSUMER_ELECTRONICS,
        id: 'CONSUMER_ELECTRONICS',
        name: 'Consumer Electronics',
        i18nBase: 'solutions:module.consumer-electronics',
        i18nId: 'solutions:module.consumer-electronics.menu-label',
        component: lazy(
            () =>
                import('../components/modules/solutions/consumer-electronics/consumer-electronics')
        ),
    },
    CREATIVE_SERVICES: {
        ...PATHS.CREATIVE_SERVICES,
        id: 'CREATIVE_SERVICES',
        name: 'CreativeServices',
        i18nBase: 'products:module.creative-services',
        i18nId: 'products:module.creative-services.menu-label',
    },
    USE_OF_AI: {
        ...PATHS.USE_OF_AI,
        id: 'USE_OF_AI',
        name: 'AI usage at Audiokinetic',
        i18nBase: 'solutions:ai-at-ak',
        i18nId: 'solutions:ai-at-ak.menu-label',
        component: lazy(() => import('@components/modules/solutions/ai-at-ak/ai-at-ak')),
    },
    DISCOVER: {
        ...PATHS.DISCOVER,
        id: 'DISCOVER',
        name: 'Discover',
        displayInMenu: false,
        i18nBase: 'solutions:module.solutions',
        i18nId: 'solutions:module.solutions.menu-label',
    },
    DISCOVER_LBE: {
        ...PATHS.DISCOVER_LBE,
        id: 'DISCOVER_LBE',
        name: 'Discover LocationBasedEntertainment',
        displayInMenu: false,
        i18nBase: 'solutions:module.solutions',
        i18nId: 'solutions:module.solutions.menu-label',
    },
});

export const DEFAULT_ROUTE = ROUTES.SOLUTIONS;
